// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top-button {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background-color: var(--e-global-color-secondary);
  color: #ffffff;
  border: none;
  padding: 0.75rem 1rem;
  cursor: pointer;
  z-index: 9999;
  border-radius: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/scroll-to-top/scroll-to-top.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iDAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AACF","sourcesContent":[".scroll-to-top-button {\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n  background-color: var(--e-global-color-secondary);\n  color: #ffffff;\n  border: none;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  z-index: 9999;\n  border-radius: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
